import { BCDataGrid, BCTreeList } from '@bimser/components';
import DataGrid2 from '../..';
import { IEditingStartEventArgs } from '../../../../entities/EventArgs';

export async function onEditingStart(
	this: DataGrid2,
	e:
		| BCDataGrid.Entities.DataGridTypes.EditingStartEvent
		| BCTreeList.Components.TreeListTypes.EditingStartEvent
) {
	const args: IEditingStartEventArgs = {
		columnName: e.column?.name,
		row: e.data,
		rowId: e.key
	};

	await this.emit('event:OnEditingStart', args);

	this.pendingEdit = true;
}
